import {UserGroupEnum} from "../domain/UserGroupModel/constants/UserGroupEnum";
import {RecentAbstractView} from "../domain/RecentModel/view/RecentAbstractView";
import {RecentMemberView} from "../domain/RecentModel/view/RecentMemberView";
import {RecentPartnerRfpView} from "../domain/RecentModel/view/RecentPartnerRfpView";
import {MessageUtil} from "./MessageUtil";


/**
 * Utilitaire pour gérer les couleurs des groupes d'utilisateurs
 */
export class UserGroupColorUtils {


    /**
     * Obtient la classe CSS de couleur selon le groupe d'utilisateur
     * @param userGroupId L'ID du groupe d'utilisateur
     * @returns La classe CSS correspondante
     */
    static getUserGroupColor(userGroupId: UserGroupEnum | null | undefined): string {
        if (!userGroupId ) {
            return "";
        }

        switch (userGroupId) {
            case UserGroupEnum.PARTNER_EXPERT_TEASING:
                return "blue"; // Premium/Expert teasers
            case UserGroupEnum.PARTNER_EXPERT:
                return "red";
            case UserGroupEnum.EXPERT_CLASSIC:
                return "lightblue"; // Experts confirmés
            case UserGroupEnum.PARTNER:
                return "lightGray"; // Partenaires premium
            case UserGroupEnum.BUYER:
                return "green"; // Acheteurs
            case UserGroupEnum.AFFILIATE:
                return "purple"; // Affiliés
            case UserGroupEnum.PROSPECT:
                return "#f59f00"; // Prospects
            case UserGroupEnum.TEAM_MEMBER:
                return "grey";
            default:
                return "black";
        }

    }

    static getUserGroupLabel(userGroupId: UserGroupEnum | null | undefined): string {


        switch (userGroupId) {
            case UserGroupEnum.BUYER:
                return  "Buyer";
            case UserGroupEnum.EXPERT_CLASSIC:
                return  "Classic";
            case UserGroupEnum.AFFILIATE:
                return  "Aff";
            case UserGroupEnum.PARTNER:
                return  "Partner";
            case UserGroupEnum.PARTNER_EXPERT:
                return  "Supplier";
            case UserGroupEnum.PARTNER_EXPERT_TEASING:
                return  "Teasing";
            case UserGroupEnum.PROSPECT:
                return  "Prospect";
            case UserGroupEnum.TEAM_MEMBER:
                return  "Team Member";
            default:
                return  "Undifined";
        }
    }



    /**
     * Obtient le libellé d'affichage pour un élément de l'historique
     * @param item L'élément de l'historique
     * @returns Le libellé à afficher
     */
    static getRecentItemDisplayLabel(item: RecentAbstractView): string {
        if (item instanceof RecentMemberView) { // TYPE_USER
            // Priorité : Nom de l'entreprise, sinon prénom + nom, sinon "Unknown User"
            if (item.memberCompanyName && item.memberCompanyName.trim()) {
                return item.memberCompanyName;
            }
            const fullName = `${item.memberFirstName || ''} ${item.memberLastName || ''}`.trim();
            return fullName || 'Unknown User';
        } else if (item instanceof RecentPartnerRfpView) { // TYPE_PARTNERRFP
            return MessageUtil.getMessage(item.businessName) + ` #${item.partnerRfpId || item.id}`;
        }

        return 'Unknown Item';
    }

    /**
     * Obtient le lien de navigation pour un élément de l'historique
     * @param item L'élément de l'historique
     * @returns Le lien de navigation
     */
    static getRecentItemNavigationLink(item: RecentAbstractView): string {
        if (item instanceof RecentMemberView) { // TYPE_USER
            return `/user/${item.memberId}/general`;
        } else if (item instanceof RecentPartnerRfpView) { // TYPE_PARTNERRFP
            return `/partner-rfps/${item.partnerRfpId}`;
        }
        return "";
    }
} 